import api from "../../../../services/api";

export const adminLogin = (email_username, password) =>
  api.post("/auth/store/admin/signin", { email_username, password });

export const userLogin = (storeId, email_username, password) =>
  api.post("/auth/store/user/signin", { storeId, email_username, password });

// --------------------
// export const login = (email, password) =>
//   api.post("/user/login", { user_email: email, user_password: password });

// export const signup = ({ email, password, fullName, cipher }) =>
//   api.post("/user/signup", {
//     user_email: email,
//     user_password: password,
//     user_name: fullName,
//     cipher: cipher,
//   });

// export const sendOtp = (email, type) =>
//   api.post("/user/sendOtp", { user_email: email, user_req_type: type });

// export const verifyOtp = (email, type, otp) =>
//   api.post("/user/verifyOtp", { user_email: email, user_req_type: type, otp });

// export const resendOtp = (email, type) =>
//   api.post("/user/resendOtp", { user_email: email, user_req_type: type });

// export const checkUniqueEmail = email =>
//   api.post("/user/validEmail", { user_email: email });

// export const updatePassword = (email, password) =>
//   api.post("user/resetPassword", {
//     user_email: email,
//     user_password: password,
//   });
